import { t } from 'i18next';
import { useRevealOnScroll } from 'src/shared';

type LpProofProps = {
  vibeUrl: string;
  eventName: string;
};

export default function LpProof({ vibeUrl, eventName }: LpProofProps) {
  const mediaRef = useRevealOnScroll<HTMLDivElement>();
  const textRef = useRevealOnScroll<HTMLDivElement>();

  return (
    <section className="section-pad proof" aria-labelledby="lp-proof-stat">
      <div className="wrap">
        <div className="proof__grid">
          <div ref={mediaRef} className="proof__media reveal">
            {vibeUrl && <img src={vibeUrl} alt="" loading="lazy" />}
            <span className="badge">
              <span className="pulse" />
              Inside {eventName}
            </span>
          </div>
          <div ref={textRef} className="reveal">
            <div className="proof__stat" id="lp-proof-stat">
              {t('landingPage.v2.proof.stat')}
              <span>{t('landingPage.v2.proof.statLabel')}</span>
            </div>
            <h3>{t('landingPage.v2.proof.heading')}</h3>
            <p>{t('landingPage.v2.proof.body')}</p>
            <div className="reassure">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
                <path d="m9 12 2 2 4-4" />
              </svg>
              <p>
                {t('landingPage.v2.proof.reassurePre')}{' '}
                <b>{t('landingPage.v2.proof.reassureBold')}</b>{' '}
                {t('landingPage.v2.proof.reassurePost')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
